import { unwrap, type WidgetDefinition } from "@nexus/widget-sdk";
import type { EventTimelineData } from "@nexus/widget-kit";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "event-scope",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Select protected event and channel scope.",
    domain: "events",
    visual: "Selector",
    purposes: ["live"],
    audiences: ["analyst"],
  },
  layout: { kind: "content" },
  // The events it lists: the one the dashboard's event filter selects names the page.
  subjects: (data) =>
    (unwrap<EventTimelineData>(data.event)?.events ?? []).map((event) => ({
      kind: "event",
      id: event.event_id,
      label: event.event_label,
    })),
  defaultLayoutClassName: "col-span-12",
};
